var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var Svg2FaApp = function Svg2FaApp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 84,
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 77a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H17a1 1 0 0 1-1-1Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 8a8 8 0 0 0-8-8H8a8 8 0 0 0-8 8v68a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8V8ZM9 3a6 6 0 0 0-6 6v66a6 6 0 0 0 6 6h30a6 6 0 0 0 6-6V9a6 6 0 0 0-6-6h-2c-.588 0-1.1.4-1.242.97A4 4 0 0 1 31.877 7H16.123a4 4 0 0 1-3.88-3.03A1.28 1.28 0 0 0 11 3H9Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m24.596 30.142 8.66 3.772c.52.22.932.565 1.237 1.037.337.471.505 1.021.505 1.65.03 1.603-.23 3.49-.78 5.658-.55 2.17-1.542 4.275-2.978 6.319-1.405 2.074-3.421 3.787-6.049 5.14-.794.376-1.588.376-2.382 0-2.628-1.353-4.644-3.066-6.05-5.14-1.435-2.044-2.428-4.15-2.978-6.319-.55-2.169-.81-4.055-.779-5.658 0-.629.168-1.179.505-1.65a2.694 2.694 0 0 1 1.237-1.037l8.66-3.773A1.29 1.29 0 0 1 24 30c.214 0 .412.047.596.142Zm4.582 9.713c.428-.535.428-1.07 0-1.603-.52-.44-1.039-.44-1.558 0l-5.086 5.233-2.154-2.216c-.52-.44-1.039-.44-1.558 0-.428.535-.428 1.069 0 1.603l2.933 3.018c.519.44 1.038.44 1.558 0l5.865-6.035Z",
    fill: "#337AB7"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg2FaApp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/2fa-app.50654bebb80a7ce1679824081792ea81.svg";
export { ForwardRef as ReactComponent };